import { render, staticRenderFns } from "./orderment.vue?vue&type=template&id=bc50c408&scoped=true&"
import script from "./orderment.vue?vue&type=script&lang=js&"
export * from "./orderment.vue?vue&type=script&lang=js&"
import style0 from "./orderment.vue?vue&type=style&index=0&id=bc50c408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc50c408",
  null
  
)

export default component.exports